import { defineMessages } from 'react-intl';

const messages = defineMessages({
  createSubsidyBatch: {
    id: 'App.CreateSubsidyBatch.CreateSubsidyBatch',
    defaultMessage: 'Create Subsidy Batch',
  },
});

export default messages;
